import { combineReducers } from 'redux';
import filtersReducer from './filters';
import authReducer from './auth';

export default combineReducers({
    auth: authReducer,
    filters: filtersReducer
});